import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function fetchLog(page) {
  return axiosInstance.get(`${BASE_URL}/api/logs?page=${page}&limit=50`);
}
